import { useState } from 'react';
import { useToast } from '../../../context';
import type { InfoFieldOption } from '../../../lib';
import type { AddTenancyPatientPayload } from '../../../lib/payloads/addTenancyPatient';
import type { RootState } from '../../../store';
import { useSelector } from 'react-redux';
import { post } from '../../../api/baseUrl';

enum OutsourceKey {
  CLINICS = 'clinics',
}

const useAddTenancyPatient = () => {
  const [loading, setLoading] = useState(false);
  const { clinics } = useSelector((state: RootState) => state.clinicianProfile);
  const { setToast } = useToast();
  const mapOutsource = (key: OutsourceKey): InfoFieldOption[] | null => {
    switch (key) {
      case OutsourceKey.CLINICS:
        return clinics.map((clinic) => ({
          label: clinic.clinic,
          value: clinic.clinic_id,
        }));
      default:
        return null;
    }
  };

  const generateOutsourceOptions = (sourceKey: string): InfoFieldOption[] => {
    const sources = mapOutsource(sourceKey as OutsourceKey);
    if (!sources) return [];
    return sources;
  };

  const addAndInvitePatient = async (data: AddTenancyPatientPayload) => {
    try {
      setLoading(true);
      const response = await post('createPatient', data);
      if (!response.data) {
        throw new Error();
      }
    } catch (error) {
      console.error('Error adding and inviting patient:', error);
      setToast('Failed to add and invite patient. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  return { generateOutsourceOptions, addAndInvitePatient, loading };
};

export default useAddTenancyPatient;
